import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/themecolors.png'


const _withScopeId = n => (_pushScopeId("data-v-48b06b3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "base-title-button"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "content_copy", -1))
const _hoisted_3 = {
  key: 1,
  class: "base-title-button"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "content_paste", -1))
const _hoisted_5 = {
  key: 2,
  class: "base-title-button"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "account_balance", -1))
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "fs-4 d-flex align-items-center" }
const _hoisted_9 = {
  key: 0,
  class: "badge bg-blue fs-6 ms-3"
}
const _hoisted_10 = {
  key: 1,
  class: "text-danger fst-italic fs-7 ms-3"
}
const _hoisted_11 = { class: "row row base-colors" }
const _hoisted_12 = { class: "col-xl-4 border-end border-2 pe-3" }
const _hoisted_13 = { class: "my-2" }
const _hoisted_14 = { class: "row align-items-center" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "my-2" }
const _hoisted_17 = { class: "row align-items-center" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "my-2" }
const _hoisted_20 = { class: "row align-items-center" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "col-xl-4 border-end border-2 pe-3" }
const _hoisted_23 = { class: "my-2" }
const _hoisted_24 = { class: "row align-items-center" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "my-2" }
const _hoisted_27 = { class: "row align-items-center" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "my-2" }
const _hoisted_30 = { class: "row justify-content-between align-items-center" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "col-xl-4" }
const _hoisted_33 = { class: "my-2" }
const _hoisted_34 = { class: "row align-items-center" }
const _hoisted_35 = { class: "col" }
const _hoisted_36 = { class: "my-2" }
const _hoisted_37 = { class: "row align-items-center" }
const _hoisted_38 = { class: "col" }
const _hoisted_39 = { class: "my-2" }
const _hoisted_40 = { class: "row justify-content-between align-items-center" }
const _hoisted_41 = { class: "col" }
const _hoisted_42 = { class: "subtitle mt-4" }
const _hoisted_43 = { class: "fs-4" }
const _hoisted_44 = { class: "row row-text-colors" }
const _hoisted_45 = { class: "col-xl-4 border-end border-2 pe-3" }
const _hoisted_46 = { class: "my-2" }
const _hoisted_47 = { class: "row align-items-center justify-content-between" }
const _hoisted_48 = { class: "col-xl-8 col-lg-12" }
const _hoisted_49 = { class: "my-2" }
const _hoisted_50 = { class: "row align-items-center justify-content-between" }
const _hoisted_51 = { class: "col-xl-8 col-lg-12" }
const _hoisted_52 = { class: "col-xl-4 border-end border-2 pe-3" }
const _hoisted_53 = { class: "my-2" }
const _hoisted_54 = { class: "row justify-content-between align-items-center" }
const _hoisted_55 = { class: "col-xl-8 col-lg-12" }
const _hoisted_56 = { class: "my-2" }
const _hoisted_57 = { class: "row justify-content-between align-items-center" }
const _hoisted_58 = { class: "col-xl-8 col-lg-12" }
const _hoisted_59 = { class: "col-xl-4" }
const _hoisted_60 = { class: "my-2" }
const _hoisted_61 = { class: "row justify-content-between align-items-center" }
const _hoisted_62 = { class: "col-xl-8 col-lg-12" }
const _hoisted_63 = { class: "my-2" }
const _hoisted_64 = { class: "row justify-content-between align-items-center" }
const _hoisted_65 = { class: "col-xl-8 col-lg-12" }
const _hoisted_66 = { class: "subtitle mt-4" }
const _hoisted_67 = { class: "fs-5" }
const _hoisted_68 = { class: "row row-light-colors" }
const _hoisted_69 = { class: "col-xl-5" }
const _hoisted_70 = { class: "row align-items-center justify-content-between" }
const _hoisted_71 = { class: "col-xl-8" }
const _hoisted_72 = { class: "col-4 flex flex-column row" }
const _hoisted_73 = {
  type: "submit",
  class: "mt-4 btn btn-primary"
}
const _hoisted_74 = { class: "row" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid d-inline-block w-75",
  alt: "Themecolors examples",
  src: _imports_0
}, null, -1))
const _hoisted_76 = {
  type: "submit",
  class: "btn btn-primary mt-5",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputColor = _resolveComponent("InputColor")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('colorScheme'),
          mb: 5,
          "show-refresh-button": "",
          onRefresh: this.reloadContent,
          "back-route": this.returnRouteObject
        }, _createSlots({ _: 2 }, [
          (this.colorSchemeUI.isReady())
            ? {
                name: "buttons",
                fn: _withCtx(() => [
                  (_ctx.AuthContext.isDpUser())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (this.copyToClipBoard && this.copyToClipBoard(...args)), ["prevent"])),
                          class: "btn btn-hover icon-link text-green"
                        }, [
                          _hoisted_2,
                          _createTextVNode(_toDisplayString(_ctx.$t('copy')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.AuthContext.isDpUser() && this.hasClipboardContent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (this.pasteFromClipBoard && this.pasteFromClipBoard(...args)), ["prevent"])),
                          class: "btn btn-hover icon-link text-green"
                        }, [
                          _hoisted_4,
                          _createTextVNode(_toDisplayString(_ctx.$t('paste')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (this.hasColorSchemeNames)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_base_modal_button, {
                          "modal-id": "modal-color-scheme-templates",
                          mode: "open",
                          class: "btn btn-hover icon-link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6,
                            _createTextVNode(_toDisplayString(_ctx.$t('chooseColorscheme')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["title", "onRefresh", "back-route"]),
        _createVNode(_component_AlertError2, {
          error: this.colorSchemeUI.getError(),
          class: "mb-5"
        }, null, 8, ["error"]),
        _createVNode(_component_BaseSpinner, {
          spin: this.colorSchemeUI.isNotReady()
        }, null, 8, ["spin"]),
        (this.colorSchemeUI.isReady())
          ? (_openBlock(), _createBlock(_component_dp_form, {
              key: 0,
              onSubmit: this.submitData,
              as: "form",
              novalidate: ""
            }, {
              default: _withCtx(({ errors }) => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h2", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.$t('baseColors')) + " ", 1),
                    (!this.isCustomColorScheme)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('theme')) + ": " + _toDisplayString(this.activeColorScheme.code), 1))
                      : _createCommentVNode("", true),
                    (this.hasUnrepresentativeColors)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('colorSchemeHasUnrepresentativeColors')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.primary_color,
                            "onUpdate:modelValue": [
                              _cache[2] || (_cache[2] = ($event: any) => ((this.colorScheme.primary_color) = $event)),
                              _cache[3] || (_cache[3] = ($event: any) => {this.onCustomColorsChanged(); this.calcColorPrimary();})
                            ],
                            label: _ctx.$t('primaryColor'),
                            name: "primaryColor",
                            "show-value": "",
                            errors: errors
                          }, null, 8, ["modelValue", "label", "errors"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.primary_lighter_color,
                            "onUpdate:modelValue": [
                              _cache[4] || (_cache[4] = ($event: any) => ((this.colorScheme.primary_lighter_color) = $event)),
                              this.onCustomColorsChanged
                            ],
                            label: _ctx.$t('primaryColorLighter'),
                            name: "primaryColorLighter",
                            "show-value": "",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.primary_light_color,
                            "onUpdate:modelValue": [
                              _cache[5] || (_cache[5] = ($event: any) => ((this.colorScheme.primary_light_color) = $event)),
                              this.onCustomColorsChanged
                            ],
                            label: _ctx.$t('primaryColorLight'),
                            name: "primaryColorLight",
                            "show-value": "",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.secondary_color,
                            "onUpdate:modelValue": [
                              _cache[6] || (_cache[6] = ($event: any) => ((this.colorScheme.secondary_color) = $event)),
                              _cache[7] || (_cache[7] = ($event: any) => {_ctx.onCustomColorsChanged(); _ctx.calcColorSecondary();})
                            ],
                            label: _ctx.$t('secondaryColor'),
                            name: "secondaryColor",
                            "show-value": "",
                            errors: errors
                          }, null, 8, ["modelValue", "label", "errors"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.secondary_lighter_color,
                            "onUpdate:modelValue": [
                              _cache[8] || (_cache[8] = ($event: any) => ((this.colorScheme.secondary_lighter_color) = $event)),
                              this.onCustomColorsChanged
                            ],
                            label: _ctx.$t('secondaryColorLighter'),
                            name: "secondaryColorLighter",
                            "show-value": "",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.secondary_light_color,
                            "onUpdate:modelValue": [
                              _cache[9] || (_cache[9] = ($event: any) => ((this.colorScheme.secondary_light_color) = $event)),
                              this.onCustomColorsChanged
                            ],
                            label: _ctx.$t('secondaryColorLight'),
                            name: "secondaryColorLight",
                            "show-value": "",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.tertiary_color,
                            "onUpdate:modelValue": [
                              _cache[10] || (_cache[10] = ($event: any) => ((this.colorScheme.tertiary_color) = $event)),
                              _cache[11] || (_cache[11] = ($event: any) => {_ctx.onCustomColorsChanged(); _ctx.calcColorTertiary();})
                            ],
                            label: _ctx.$t('tertiaryColor'),
                            name: "tertiaryColor",
                            "show-value": "",
                            errors: errors
                          }, null, 8, ["modelValue", "label", "errors"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.tertiary_lighter_color,
                            "onUpdate:modelValue": [
                              _cache[12] || (_cache[12] = ($event: any) => ((this.colorScheme.tertiary_lighter_color) = $event)),
                              this.onCustomColorsChanged
                            ],
                            label: _ctx.$t('tertiaryColorLighter'),
                            name: "tertiaryColorLighter",
                            "show-value": "",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.tertiary_light_color,
                            "onUpdate:modelValue": [
                              _cache[13] || (_cache[13] = ($event: any) => ((this.colorScheme.tertiary_light_color) = $event)),
                              this.onCustomColorsChanged
                            ],
                            label: _ctx.$t('tertiaryColorLight'),
                            name: "tertiaryColorLight",
                            "show-value": "",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("h2", _hoisted_43, _toDisplayString(_ctx.$t('textColors')), 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.text_color_on_primary_color,
                            "onUpdate:modelValue": [
                              _cache[14] || (_cache[14] = ($event: any) => ((this.colorScheme.text_color_on_primary_color) = $event)),
                              this.onCustomColorsChanged
                            ],
                            label: _ctx.$t('textColorPrimary'),
                            name: "textColorPrimary",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                        ]),
                        _createElementVNode("div", {
                          class: "col-3 example me-3",
                          style: _normalizeStyle({'background-color': this.colorScheme.primary_color, 'color': this.colorScheme.text_color_on_primary_color})
                        }, [
                          _createElementVNode("p", null, _toDisplayString(this.colorScheme.text_color_on_primary_color), 1)
                        ], 4)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.text_color_on_primary_lighter_color,
                            "onUpdate:modelValue": [
                              _cache[15] || (_cache[15] = ($event: any) => ((this.colorScheme.text_color_on_primary_lighter_color) = $event)),
                              this.onCustomColorsChanged
                            ],
                            label: _ctx.$t('textColorPrimaryLight'),
                            name: "textColorPrimaryLight",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                        ]),
                        _createElementVNode("div", {
                          class: "col-3 example me-3",
                          style: _normalizeStyle({'background-color': this.colorScheme.primary_lighter_color, 'color': this.colorScheme.text_color_on_primary_lighter_color })
                        }, [
                          _createElementVNode("p", null, _toDisplayString(this.colorScheme.text_color_on_primary_lighter_color), 1)
                        ], 4)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.text_color_on_secondary_color,
                            "onUpdate:modelValue": [
                              _cache[16] || (_cache[16] = ($event: any) => ((this.colorScheme.text_color_on_secondary_color) = $event)),
                              this.onCustomColorsChanged
                            ],
                            label: _ctx.$t('textColorSecondary'),
                            name: "textColorSecondary",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                        ]),
                        _createElementVNode("div", {
                          class: "col-3 example me-3",
                          style: _normalizeStyle({'background-color': this.colorScheme.secondary_color, 'color': this.colorScheme.text_color_on_secondary_color })
                        }, [
                          _createElementVNode("p", null, _toDisplayString(this.colorScheme.text_color_on_secondary_color), 1)
                        ], 4)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.text_color_on_secondary_lighter_color,
                            "onUpdate:modelValue": [
                              _cache[17] || (_cache[17] = ($event: any) => ((this.colorScheme.text_color_on_secondary_lighter_color) = $event)),
                              this.onCustomColorsChanged
                            ],
                            label: _ctx.$t('textColorSecondaryLight'),
                            name: "textColorSecondaryLight",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                        ]),
                        _createElementVNode("div", {
                          class: "col-3 example me-3",
                          style: _normalizeStyle({'background-color': this.colorScheme.secondary_lighter_color, 'color': this.colorScheme.text_color_on_secondary_lighter_color })
                        }, [
                          _createElementVNode("p", null, _toDisplayString(this.colorScheme.text_color_on_secondary_lighter_color), 1)
                        ], 4)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.text_color_on_tertiary_color,
                            "onUpdate:modelValue": [
                              _cache[18] || (_cache[18] = ($event: any) => ((this.colorScheme.text_color_on_tertiary_color) = $event)),
                              this.onCustomColorsChanged
                            ],
                            label: _ctx.$t('textColorTertiary'),
                            name: "textColorTertiary",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                        ]),
                        _createElementVNode("div", {
                          class: "col-3 example me-3",
                          style: _normalizeStyle({'background-color': this.colorScheme.tertiary_color, 'color': this.colorScheme.text_color_on_tertiary_color })
                        }, [
                          _createElementVNode("p", null, _toDisplayString(this.colorScheme.text_color_on_tertiary_color), 1)
                        ], 4)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createVNode(_component_InputColor, {
                            modelValue: this.colorScheme.text_color_on_tertiary_lighter_color,
                            "onUpdate:modelValue": [
                              _cache[19] || (_cache[19] = ($event: any) => ((this.colorScheme.text_color_on_tertiary_lighter_color) = $event)),
                              this.onCustomColorsChanged
                            ],
                            label: _ctx.$t('textColorTertiaryLight'),
                            name: "textColorTertiaryLight",
                            errors: errors
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                        ]),
                        _createElementVNode("div", {
                          class: "col-3 example me-3",
                          style: _normalizeStyle({'background-color': this.colorScheme.tertiary_lighter_color, 'color': this.colorScheme.text_color_on_tertiary_lighter_color })
                        }, [
                          _createElementVNode("p", null, _toDisplayString(this.colorScheme.text_color_on_tertiary_lighter_color), 1)
                        ], 4)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("h2", _hoisted_67, _toDisplayString(_ctx.$t('textOnLightColors')), 1)
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_InputColor, {
                          modelValue: this.colorScheme.text_color_on_light_color,
                          "onUpdate:modelValue": [
                            _cache[20] || (_cache[20] = ($event: any) => ((this.colorScheme.text_color_on_light_color) = $event)),
                            this.onCustomColorsChanged
                          ],
                          label: _ctx.$t('textColorLight'),
                          name: "textColorLight",
                          errors: errors
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", {
                          class: "col-10 example mb-3",
                          style: _normalizeStyle({'background-color': this.colorScheme.primary_light_color, 'color': this.colorScheme.text_color_on_light_color })
                        }, [
                          _createElementVNode("p", null, _toDisplayString(this.colorScheme.text_color_on_light_color), 1)
                        ], 4),
                        _createElementVNode("div", {
                          class: "col-10 example",
                          style: _normalizeStyle({'background-color': this.colorScheme.secondary_light_color, 'color': this.colorScheme.text_color_on_light_color })
                        }, [
                          _createElementVNode("p", null, _toDisplayString(this.colorScheme.text_color_on_light_color), 1)
                        ], 4)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("button", _hoisted_73, _toDisplayString(_ctx.$t('save')), 1)
              ]),
              _: 1
            }, 8, ["onSubmit"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_base_modal, {
      "modal-id": "modal-color-scheme-templates",
      title: _ctx.$t('colorScheme'),
      "dialog-classes": "modal-lg",
      "no-footer": ""
    }, {
      default: _withCtx(() => [
        (this.colorSchemeUI.isReady() && this.hasColorSchemeNames)
          ? (_openBlock(), _createBlock(_component_dp_form, {
              key: 0,
              onSubmit: this.submitData,
              as: "form",
              novalidate: ""
            }, {
              default: _withCtx(({ errors }) => [
                _createElementVNode("div", _hoisted_74, [
                  _createVNode(_component_InputSelect, {
                    modelValue: this.activeColorScheme.code,
                    "onUpdate:modelValue": [
                      _cache[21] || (_cache[21] = ($event: any) => ((this.activeColorScheme.code) = $event)),
                      this.onTemplateColorSchemeChanged
                    ],
                    options: this.colorSchemeNames,
                    label: _ctx.$t('colorScheme'),
                    name: "$t('save')",
                    class: "mb-4 col-6",
                    errors: errors
                  }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "label", "errors"]),
                  _hoisted_75
                ]),
                _createElementVNode("button", _hoisted_76, _toDisplayString(_ctx.$t('save')), 1)
              ]),
              _: 1
            }, 8, ["onSubmit"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}